import type { GetTeacherResponse } from "@/openapi/generated/models";

type TeacherNameFields = Pick<
  GetTeacherResponse,
  "firstName" | "lastName" | "preferredName"
>;

/** Display name for public teacher cards and headings. */
export function getTeacherPublicDisplayName(teacher: TeacherNameFields): {
  heading: string;
  subline: string | null;
} {
  const first = (teacher.firstName ?? "").trim();
  const last = (teacher.lastName ?? "").trim();
  const full = `${first} ${last}`.trim();
  const pref = (teacher.preferredName ?? "").trim();

  if (!pref) {
    return { heading: full, subline: null };
  }

  const prefL = pref.toLowerCase();
  const fullL = full.toLowerCase();
  const firstL = first.toLowerCase();

  if (prefL === fullL || prefL === firstL) {
    return { heading: full, subline: null };
  }

  return { heading: pref, subline: full };
}

export function getTeacherPublicShortName(teacher: TeacherNameFields): string {
  const pref = teacher.preferredName?.trim();
  if (pref) return pref;
  return `${teacher.firstName ?? ""} ${teacher.lastName ?? ""}`.trim();
}

export function getActivePublicTeachers(
  teachers: GetTeacherResponse[] | undefined,
): GetTeacherResponse[] {
  return (teachers ?? [])
    .filter((teacher) => teacher.isActive !== false)
    .sort((a, b) =>
      getTeacherPublicShortName(a).localeCompare(
        getTeacherPublicShortName(b),
        "en",
        { sensitivity: "base" },
      ),
    );
}
